import { render, staticRenderFns } from "./index.vue?vue&type=template&id=18da96a8"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18da96a8')) {
      api.createRecord('18da96a8', component.options)
    } else {
      api.reload('18da96a8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=18da96a8", function () {
      api.rerender('18da96a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/promo/index.vue"
export default component.exports